import React, {Fragment} from 'react';

import {Typography} from '@mui/material';
import {ErrorState} from 'presentation/components';
import {Drawer} from 'presentation/components/Drawer';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';

import {Loading} from './components/Loading';
import {SpecialtyDetailsDrawerProps} from './types';
import {useGetHealthSpecialtyDescriptionQuery} from '../../../queries/useGetHealthSpecialtyDescriptionQuery';
import {StyledTypography} from './styles';

const {title} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow.specialtyDetailsDrawer;
const {failToLoadTitle, failToLoadDescription} = translations['pt-br'].commons;

export function SpecialtyDetailsDrawer({
	isOpen,
	onClose,
	onOpen,
	specialtyName,
	specialtyCode,
}: SpecialtyDetailsDrawerProps) {
	const {isMobile} = useMediaQueries();
	const {data, isFetching, isError, refetch} = useGetHealthSpecialtyDescriptionQuery({
		specialtyCode,
	});

	return (
		<Drawer.Root
			open={isOpen}
			onClose={onClose}
			onOpen={onOpen}
			width="396px"
			customMaxHeight="100%"
			sx={{zIndex: 9000}}>
			<Drawer.Header onClose={onClose} title={title} />
			<Drawer.Content mt={isMobile ? 0 : 1.5} gap={1} mb={3}>
				{isFetching ? <Loading /> : null}

				{isError ? (
					<ErrorState
						title={failToLoadTitle}
						description={failToLoadDescription}
						handleRefresh={refetch}
					/>
				) : null}

				{data ? (
					<Fragment>
						<Typography variant="subtitle2" color="text.secondary" fontSize={16}>
							{specialtyName}
						</Typography>
						<StyledTypography
							variant="body1"
							dangerouslySetInnerHTML={{__html: data.content.description}}
						/>
					</Fragment>
				) : null}
			</Drawer.Content>
		</Drawer.Root>
	);
}
